import { HoldingClass, Partner, StockPlan } from 'types';

import CustomLoading from 'modules/_shared/components/CustomLoading';

import { hasMaintenancePartnerBook } from 'utils/showDetails';
import ClassesTable from '../components/ClassesTable';
import PartnerBookTable from '../components/PartnerBookTable';
import CommercialRegisterTable from '../components/CommercialRegisterTable';

import {
  PartnerBook,
  PartnerBookPartnersRegister,
  PartnerBookRows,
  PartnerBookUpdatedPartner,
} from '../types/PartnerBook';
import PartnerBookMaintenanceWarning from '../components/PartnerBookMaintenanceWarning';

type PartnerBookViewsProps = {
  view: number;
  bookData: PartnerBookRows;
  partnerBook: PartnerBook;
  partnersRegister: PartnerBookPartnersRegister;
  partners: Partner[];
  plans: StockPlan[];
  holdingClasses: HoldingClass[];
  draftView: boolean;
  updatedPartners: PartnerBookUpdatedPartner[];
  convertibleNoteView: boolean;
  capitalizedNote: boolean;
};

export const usePartnerBookViews = ({
  view,
  bookData,
  partnerBook,
  partnersRegister,
  partners,
  plans,
  holdingClasses,
  draftView,
  updatedPartners,
  convertibleNoteView, // TODO: check if this is not necessary
  capitalizedNote, // TODO: check if this is not necessary
}: PartnerBookViewsProps) => {
  const {
    bookDates,
    bookColumns,
    bookHeaders,
    bookComments,
    bookPartners,
    bookOperations,
    bookTotals,
    bookTotalPartners,
    bookOrder,
    bookDocuments,
  } = bookData;

  const renderPartnerBookTable = () => {
    if (!partnerBook) {
      return <CustomLoading />;
    }

    return (
      <PartnerBookTable
        view={view}
        // @ts-ignore
        partnerBook={partnerBook}
        bookDates={bookDates}
        bookColumns={bookColumns}
        bookHeaders={bookHeaders}
        bookComments={bookComments}
        bookPartners={bookPartners}
        bookOperations={bookOperations}
        bookTotals={bookTotals}
        bookTotalPartners={bookTotalPartners}
        bookOrder={bookOrder}
        bookDocuments={bookDocuments}
        isForScreen
      />
    );
  };

  const renderCommercialRegisterTable = () => {
    if (!partnersRegister || !partners.length) {
      return <CustomLoading />;
    }

    return (
      <>
        <CommercialRegisterTable
          view={view}
          partnersRegister={partnersRegister}
          text
        />
        <CommercialRegisterTable
          view={view}
          partnersRegister={partnersRegister}
        />
      </>
    );
  };

  const renderClassesTable = () => {
    if (hasMaintenancePartnerBook()) {
      return <PartnerBookMaintenanceWarning />;
    }

    if (partners.length === 0 || !plans || holdingClasses.length === 0) {
      return <CustomLoading />;
    }

    return (
      <>
        <ClassesTable
          view={view}
          draftView={draftView}
          updatedPartners={updatedPartners}
          // convertibleNoteView={convertibleNoteView}
          // capitalizedNote={capitalizedNote}
          text
        />
        <ClassesTable
          view={view}
          draftView={draftView}
          updatedPartners={updatedPartners}
          // convertibleNoteView={convertibleNoteView}
          // capitalizedNote={capitalizedNote}
        />
      </>
    );
  };

  const renderClassesTableInversionTable = () => {
    if (hasMaintenancePartnerBook()) {
      return <PartnerBookMaintenanceWarning />;
    }

    if (partners.length === 0 || !plans || holdingClasses.length === 0) {
      return <CustomLoading />;
    }

    return (
      <>
        <ClassesTable
          view={view}
          draftView={draftView}
          updatedPartners={updatedPartners}
          // convertibleNoteView={convertibleNoteView}
          // capitalizedNote={capitalizedNote}
          inversionView
          text
        />
        <ClassesTable
          view={view}
          draftView={draftView}
          updatedPartners={updatedPartners}
          // convertibleNoteView={convertibleNoteView}
          // capitalizedNote={capitalizedNote}
          inversionView
        />
      </>
    );
  };

  const renderClassesTableInvestorsTable = () => {
    if (hasMaintenancePartnerBook()) {
      return <PartnerBookMaintenanceWarning />;
    }

    if (partners.length === 0 || !plans || holdingClasses.length === 0) {
      return <CustomLoading />;
    }

    return (
      <>
        <ClassesTable
          view={view}
          draftView={draftView}
          updatedPartners={updatedPartners}
          // convertibleNoteView={convertibleNoteView}
          // capitalizedNote={capitalizedNote}
          investorsView
          text
        />
        <ClassesTable
          view={view}
          draftView={draftView}
          updatedPartners={updatedPartners}
          // convertibleNoteView={convertibleNoteView}
          // capitalizedNote={capitalizedNote}
          investorsView
        />
      </>
    );
  };

  return {
    data: {
      renderPartnerBookTable,
      renderCommercialRegisterTable,
      renderClassesTable,
      renderClassesTableInversionTable,
      renderClassesTableInvestorsTable,
    },
  };
};
